import { render, staticRenderFns } from "./settings.html?vue&type=template&id=2f4de3d2&scoped=true&external"
import script from "./settings.js?vue&type=script&lang=js&external"
export * from "./settings.js?vue&type=script&lang=js&external"
import style0 from "./settings.scss?vue&type=style&index=0&id=2f4de3d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4de3d2",
  null
  
)

export default component.exports